import Model from './model.js'

export default { 
  ReadByWork: function(params) {
    Model.ReadByWork(params);
  },
  Register: function(params) {
    Model.Register(params);
  },
  Update: function(params) {
    Model.Update(params);
  },
}


// WEBPACK FOOTER //
// ./src/App/remainder/presenter.js